import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import HeaderBlock from "@/components/HeaderBlock.vue";
import TileInvoices from "@/components/TileInvoices.vue";
import MainContentBase from "@/components/layout/MainContentBase.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ClientInvoices',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainContentBase, null, {
    default: _withCtx(() => [
      _createVNode(HeaderBlock, { class: "header" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("titles.myInvoices")), 1)
        ]),
        _: 1
      }),
      _createVNode(TileInvoices, { class: "invoices" })
    ]),
    _: 1
  }))
}
}

})